import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { getAttrValue } from '@grandvisionhq/utils';
import { getPrescriptionState } from './utils/get-prescription-state.js';

const useLenses = ({ product , cartDiscounts , isPrescriptionEnabled , isPrescriptionInfoEnabled , variant  })=>{
    var ref;
    const packageQuantity = Number(getAttrValue(product.masterVariant, 'packageQuantity'));
    /**
   * Stores the pack price, this updates when a different pack size is selected
   */ const [packPrice, setPackPrice] = React.useState((ref = product.masterVariant.prices) === null || ref === void 0 ? void 0 : ref[0]);
    const [clbbPrice, setCLBBPrice] = React.useState();
    /**
   * Selected prescription state which keeps track of the selected lenses
   * and the corresponding prices
   */ const [lensesState, setLensesState] = React.useState({
        packageQuantity,
        selectedProducts: [],
        totalPrice: 0,
        totalCLBBPrice: 0,
        totalDiscount: undefined
    });
    /**
   * Keeps track of the availability and the selected lenses,
   * these are used in the DeliveryIndicator
   */ const [availability1, setAvailability] = React.useState([]);
    const [selectedLensVariants, setSelectedLensVariants] = React.useState([]);
    /**
   * Keeps track of the error states for the configurator and prescriptionInfo,
   * the error count is used for re-rendering the error Alert components
   */ const [formValidations, setFormValidations] = React.useState({
        errorCount: 0,
        showError: false,
        isConfiguratorValid: false,
        isPrescriptionInfoValid: !isPrescriptionEnabled
    });
    /**
   * Keeps track of the when to show the MiniCart
   */ const [showMiniCart1, setShowMiniCart] = React.useState(false);
    /**
   * Click handler assigned to the enter prescription button
   * Clicking this button always means the user has not filled in
   * the requested forms completely.
   */ const handlePrescriptionClick = React.useCallback(()=>{
        setFormValidations(swcHelpers.objectSpread({}, formValidations, {
            showError: true,
            errorCount: formValidations.errorCount + 1
        }));
    }, [
        formValidations
    ]);
    /**
   * Contact lens configurator callback
   * This will derive the different states based on the form
   */ const handleFormChange = React.useCallback((config)=>{
        const { prescriptionResult , availability , formErrorState , selectedVariantsData  } = getPrescriptionState(config, !!isPrescriptionInfoEnabled, variant, cartDiscounts);
        setPackPrice(config.packPrice);
        setCLBBPrice(config.clbbPrice);
        setLensesState(prescriptionResult);
        setAvailability(availability);
        setSelectedLensVariants(selectedVariantsData);
        setFormValidations(swcHelpers.objectSpread({}, formValidations, formErrorState, {
            showError: false
        }));
    }, [
        formValidations,
        isPrescriptionInfoEnabled,
        variant,
        cartDiscounts
    ]);
    /**
   * MiniCart change handler, will fire when user proceeds to purchase lenses
   */ const handleMiniCartChange = React.useCallback(()=>{
        setShowMiniCart((showMiniCart)=>{
            return !showMiniCart;
        });
    }, []);
    const priceTotals = React.useMemo(()=>({
            calculatedPrice: lensesState.totalPrice,
            calculatedDiscountPrice: lensesState.totalDiscount,
            selectedProducts: lensesState.selectedProducts,
            clbbCalculatedPrice: lensesState.totalCLBBPrice
        })
    , [
        lensesState
    ]);
    const state = React.useMemo(()=>({
            availability: availability1,
            hasLenses: !!lensesState.selectedProducts.length,
            formValidations,
            packPrice,
            clbbPrice,
            priceTotals,
            selectedLensVariants,
            showMiniCart: showMiniCart1
        })
    , [
        availability1,
        lensesState,
        formValidations,
        packPrice,
        clbbPrice,
        priceTotals,
        selectedLensVariants,
        showMiniCart1, 
    ]);
    const handles = React.useMemo(()=>({
            handleFormChange,
            handleMiniCartChange,
            handlePrescriptionClick
        })
    , [
        cartDiscounts
    ]);
    return React.useMemo(()=>[
            state,
            handles
        ]
    , [
        handles,
        state
    ]);
};

export { useLenses };
//# sourceMappingURL=hooks.js.map
